import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ProfileSitePackageBox, ProfileNoPackage, ProfilePackageBox, ProfilePackageBoxShimmer, ProfileSitePackageBoxShimmer } from "src/components";
import { _ } from "src/services";
import { ProfileData, ProfileDataAction } from "src/store";

export const ProfilePackages: React.FC = () => {

    //#region depenencies
    const dispatch = useDispatch();
    const user: ProfileData = useSelector((state: any) => state.ProfileDataState);

    //#endregion

    //#region properties

    const packages = user.packageSummaries;

    //#endregion

    //#region effects

    useEffect(() => {
        dispatch(ProfileDataAction.requestPackageSummaries());
    }, [dispatch]);

    //#endregion

    if (!packages.loading && !packages.firstLoad && (!packages.packages || packages.packages.length === 0)) {
        return (<ProfileNoPackage />);
    }

    if ( packages.loading && (!packages.packages || packages.packages.length === 0)) {
        return (
            <div className="px-3 px-md-0">
                <h3 className="profile-sub-title">{_("activePackages")}</h3>
                {[...new Array(3)].map((x, index) => <ProfilePackageBoxShimmer key={index} />)}
                <h3 className="profile-sub-title pt-4">{_("otherPackages")}</h3>
                {[...new Array(3)].map((x, index) => <ProfileSitePackageBoxShimmer key={index} />)}
            </div>
        );
    }

    return (
        <div className="px-3 px-md-0">
            {packages.packages.length > 0 && <h3 className="profile-sub-title">{_("activePackages")}</h3>}
            {packages.packages.map((p, index) => (<ProfilePackageBox key={index} {...p} />))}
            {packages.sitePackages.length > 0 && <h3 className="profile-sub-title pt-4">{_("otherPackages")}</h3>}
            {packages.sitePackages.map((p, index) => (<ProfileSitePackageBox key={index} {...p} />))}
        </div>
    );

};